export default {
    myEducationalMaterial: "My Educational Materials",
    addEducationalMaterial: "Add Educational Material",
}